'use strict';

module.exports = function (ngModule) {
    ngModule.controller('LoginCtrl', require('./login'));
    ngModule.controller('twoStep', require('./twostep'));
    ngModule.controller('setPassword', require('./setpass'));
    ngModule.controller('forgotPass', require('./forgot'));
}


/** WEBPACK FOOTER **
 ** ./src/auth/controllers/index.js
 **/